import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/a3c10059-1c76-4d51-8e83-0be9a7b8588b",
        "alt": "An image displaying a checkbox with a checkbox and label."
      }}></img></p>
    <ul>
      <li parentName="ul">{`Checkbox: A selection control.`}</li>
      <li parentName="ul">{`Label: A description for the checkbox.`}</li>
    </ul>
    <h2>{`Usage`}</h2>
    <p>{`Use checkboxes to allow users to select multiple items from a list of individual items, or to mark one individual item as selected. Unlike the `}<a parentName="p" {...{
        "href": "/components/Radio"
      }}>{`Radio`}</a>{` component or `}<a parentName="p" {...{
        "href": "/components/Select"
      }}>{`Select`}</a>{` component, Checkbox does not restrict users to choosing just a single option.`}</p>
    <p>{`Checkbox labels should be descriptive and concise. Write labels in sentence case.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/59d4b8da-1b59-418f-ae59-d2c6347376db" />
    <Caption mdxType="Caption">Checkbox labels should be descriptive and concise.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/15d2412e-0adf-4449-97c1-fa51f7d0c2a7" />
    <Caption mdxType="Caption">
      Don't make checkbox labels confusing, indirect, and avoid negative
      statements.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/01763c28-bccf-4aad-8179-1669667b4be0" />
    <Caption mdxType="Caption">
      Use consistent styling (starting with capitalization and not ending with
      punctuation).
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/da0effd9-8111-44e6-a633-85f4baf2cb7a" />
    <Caption mdxType="Caption">
      Don't have inconsistent styling (not starting with capitalization or
      ending in punctuation).
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/20a8d220-0875-49e6-a522-96192f51cc3b" />
    <Caption mdxType="Caption">
      Use first-person when asking users for acknowledgement or consent.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/8ee9b08c-0a3d-4ff4-a6fa-224632597461" />
    <Caption mdxType="Caption">
      Don't use third-person when asking users for acknowledgement or consent.
    </Caption>
  </Dont>
    </DoDontContainer>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/845c98ad-3c22-4ba1-8c14-5d978e39d51c" />
    <Caption mdxType="Caption">
      Create checkbox options that are non-exclusive and allow for multiple
      selections.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/9747bf90-8e45-45f0-9ff7-80e70effd1c8" />
    <Caption mdxType="Caption">
      Don't use checkbox options exclusive to one another. They should not be
      automatically deselected.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`States`}</h3>
    <p>{`Checkboxes have static dimensions and four different states: rest (default), checked, indeterminate, and disabled.`}</p>
    <p>{`An indeterminate checkbox state should be used if the input value is neither true nor false. This can be useful in situations where you are required to display an incomplete state, or one that is dependent on other input selections to determine a value.`}</p>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/172e18b6-449e-4d3b-b3d0-a750df56fb77",
        "alt": null
      }}></img></p>
    <h2>{`Accessibility`}</h2>
    <p>{`Please use `}<a parentName="p" {...{
        "href": "/components/FormControl"
      }}>{`FormControl`}</a>{` to display accessible checkboxes in the UI. This Checkbox component is intended only as an ingredient for other custom components, or as a drop-in replacement for native HTML checkboxes outside of form use-cases.`}</p>
    <p>{`If you intend to use this component as part of another component, it should always be accompanied by a corresponding `}<inlineCode parentName="p">{`<label>`}</inlineCode>{` to improve support for assistive technologies.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Radio"
        }}>{`Radio`}</a>{`: Use the radio component when a user needs to select one option from a list.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Select"
        }}>{`Select`}</a>{`: Use the select component to enable selection of one option from a list.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/FormControl"
        }}>{`FormControl`}</a>{`: Use the form control component to display form inputs alongside labels, validation and more.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      